import { WordObject } from '../../interfaces/word-object/WordObject';
import { ITEM_TYPES } from '../../item/item-types';
import { MESSAGE_TYPES } from '../../item/message-types';
import { AbstractChatMessage } from './abstract-chat-message';
import { DictionaryContent } from './dictionary-content-interface';
import { MessageData } from './message-data';

export class DictionaryMessage extends AbstractChatMessage {
    content: DictionaryContent;
    words: WordObject[]=[];
    public maxWordToShow: number = 3;

    constructor(){
        super()
        this.setType(MESSAGE_TYPES.Dictionary)
    }
    setMaxWordToShow(maxWordToShowNumber: number) {
        this.maxWordToShow = maxWordToShowNumber;
    }
    setContent(data: DictionaryContent){
        this.content = data;
    }
    hasContent(): boolean {
        return this.words.length > 0
    }

    getContentString() {
        return this.content.title
    }
}